import * as apiUrl from "./ApiUrl-CPB";

export default {
    data() {
        return {
            apiUrl
        }
    }
};
